<template>
    <div v-if="props.visible" class="modal-overlay">
        <div class="modal-content">
            <form @submit.prevent="onSubmit">
                <div class="row row-space">
                    <div class="form-item">
                        <label class="label-caption">{{ props.caption }}</label>
                        <input 
                            type="text" 
                            :maxlength="props.maxsize" 
                            v-model="edValor" 
                            required 
                            v-uppercase 
                        />
                    </div>
                </div>

                <div class="row-end">
                    <button @click="closeModal">Retornar</button>
                    <button type="submit" class="btn-confirm">Confirmar</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    visible: { type: Boolean, required: true },
    caption: { type: String, default: 'Justificativa' },
    maxsize: { type: Number, default: 100 }
});

const emit = defineEmits(['update:visible', 'submit']);

const edValor = ref('');

const onSubmit = () => {
    emit('submit', { valor: edValor.value });
    closeModal();
};

const closeModal = () => {
    emit('update:visible', false);
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}
</style>
